import { useState, useEffect } from "react";

const Clock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      {time.toLocaleDateString("zh-CN")} {time.toLocaleTimeString("zh-CN")}
    </div>
  );
};

export default Clock;
